<template>
  <div class="forgotPasswordContainer">
    <div class="row">
      <div class="col-lg-3"></div>
      <div class="col-lg-6 content">
        <div>
          <h3 class="mb-5 text-black title">
            Academic Information System
          </h3>
        </div>

        <div class="col-lg-10 containerForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">

            <div class="d-flex justify-content-center flex-column align-items-center">
              <img alt="Pic" :src="picture" style="margin-bottom: 30px;" />
              <p style="font-size: 14px; font-weight: bold; margin-bottom: 5px; text-align: center; color: #56648F;">
                Kata Sandi Sudah Diubah
              </p>
              <p style="margin-bottom: 40px; text-align: center; color: #56648F;">Pakai kata sandimu yang baru untuk masuk
                lagi ke siak. Jangan bagikan
                kata sandi ini ke siapapun, ya!</p>
            </div>

            <div class="form-group d-flex flex-wrap justify-content-between align-items-center">
              <button ref="kt_login_signin_submit" class="btn font-weight-bold my-3 font-size-3 btn-login"
                style="flex: 1 0 auto; background-color: #4367AE; color: white; border-radius:10px; height:41px;"
                @click="$router.push('/login')">
                Masuk Ke Siak
              </button>
            </div>
          </b-form>
        </div>
      </div>
      <div class="col-lg-3"></div>
      <div class="footer">
        <p>FAQ | Features | Support</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$orange : #E64200;


::-webkit-scrollbar {
  width: 0px;
  background-color: transparent;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.btn-login {
  transition: box-shadow 300ms ease-in-out, color 300ms ease-in-out;
  outline: none;

  &:hover {
    box-shadow: 0 0 40px 40px $orange inset;
    transform: translate(-3px, -3px) scale(1.02);
    border-color: $orange;
  }
}
</style>

<script>


export default {
  computed: {
    picture() {
      return process.env.BASE_URL + "media/assets/forgotpasswordsuccess.png";
    }
  }
};
</script>
